import { Link } from 'react-router-dom'
import { BrandRoutes } from '../../brands/BrandRoutes'
import { CreatorRoutes } from '../../creators/CreatorRoutes'

export const FooterClip = ({ clip, type, className = '' }) => {
  return (
    <>
      <dl>
        <div className='grid grid-cols-1 -mb-2 pt-1'>
          {type === 'brand' && (
            <div>
              <div className='mt-1 text-sm text-gray-900'>
                <Link
                  to={BrandRoutes.campaignView
                    .replace(':id', `${clip.campaign.brand.id}`)
                    .replace(':campaignId', `${clip?.campaign.id}`)}
                  className='mr-1 text-sm font-semibold text-blue-600 hover:text-blue-500'
                >
                  <div className='flex items-start truncate w-5/6'>
                    {clip?.campaign?.title}
                  </div>
                </Link>
              </div>
            </div>
          )}

          {type === 'creator' && (
            <div>
              {/* <dt className='text-sm font-medium text-gray-500'>Brand</dt> */}
              <div className='mt-1 text-sm text-gray-900'>
                <Link
                  to={CreatorRoutes.collaborationViewBriefDetails
                    .replace(':id', `${clip.creator.id}`)
                    .replace(':uuid', `${clip.collaboration.uuid}`)}
                  className='mr-1 text-sm font-semibold text-blue-600 hover:text-blue-500'
                >
                  <div className='flex items-start truncate w-5/6'>
                    {clip.campaign.product.name}
                  </div>
                </Link>
              </div>
            </div>
          )}
        </div>
      </dl>
    </>
  )
}
